import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { discovery } from '../../redux/actions';
import Game from './components/Game';
import StaticGameScreen from './components/StaticGameScreen';
import { __ } from '../../locales';
import { trackEvent } from '../../helpers/common';
import events from '../../app/events';

const Container = styled.div`
  overflow: hidden;
  position: fixed;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  min-height: calc(100vh - 40px - ${Number(window.statusBarHeight || 0)}px);
  margin-top: ${Number(window.statusBarHeight || 0)}px;
`;

const Image = styled.img`
  position: fixed;
  height: 30%;
  width: 50%;
  visibility: hidden;
`;

const PleaseWait = styled.h2`
  font-size: 2.33vh;
  position: fixed;
  top: calc(50% + 80px);
  left: calc(50% - 40px)
`;

const LoadingComp = styled.div`
  overflow: hidden;
  position: fixed;
  top: calc(50% - 40px);
  left: calc(50% - 40px);
  border: 10px solid #f3f3f3;
  border-top: 10px solid #3498db;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  animation: spin 1s linear infinite;
  transition: width 0s linear;
  animation-name: in-out;
  animation-timing-function: linear;

  @keyframes in-out {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

/**
 * Display Recycle RIGHT game.
 * If it is user's first time to play the game, it will show onBoarding screens,
 * else, it will start the game
 *
 * @author: Ashkan
 * @param {object} recycleRightData Recycle RIGHT game's data
 * @returns {object}
 */

const RecycleRIGHT = ({ recycleRightData }) => {
  /* const games = recycleRightData; */

  /**
   * Create variables to check the on boarding status
   * if the user already saw the oboarding screen for tutorial will navigate to the game
   * in order to check user saw the onbaordin, onBoardingState key from local host will be checked
   */
  const onBoardingState = localStorage.getItem('onBoardingState');
  const [onBoardingStatus, setOnBoardingStatus] = useState(onBoardingState ? 'inGame' : 'firstTutorialScreen');
  const [countDownWaiting, setCountDownWaiting] = useState(false);

  const goNext = () => {
    if (onBoardingStatus === 'firstTutorialScreen') {
      setOnBoardingStatus('secondTutorialScreen');
    } else {
      localStorage.setItem('onBoardingState', 'inGame');
      setOnBoardingStatus('inGame');
    }
  };

  const sampleDoneMaterials = [
    'correct-252', 'correct-610', 'wrong-34', 'wrong-2997', 'wrong-192',
    'correct-445', 'correct-81', 'wrong-2806', 'wrong-2969', 'correct-2827',
    'correct-2910', 'wrong-28', 'correct-35', 'correct-359'
  ];

  /**
   * Before starting the game all the materials images (by their urls) will be loaded
   */
  const loadedImages = [];
  const gameImages = [];
  const [isLoaded, setIsLoaded] = useState(false);
  Object.keys(recycleRightData).forEach((key) => {
    recycleRightData[key].forEach((element) => gameImages.push(element.mat_image));
  });

  const onLoad = (index) => {
    loadedImages.push(index);
    if (loadedImages.length === gameImages.length) {
      setIsLoaded(true);
      setTimeout(() => {
        setCountDownWaiting(true);
      }, 6000);
    }
  };

  useEffect(() => {
    trackEvent(events.DZ_RR_LAND);
  }, []);

  return (
    <Container onClick={goNext}>
      {
        onBoardingStatus === 'firstTutorialScreen'
        && (
          <StaticGameScreen
            questionIndex={4}
            currentLevel={1}
            modalVisible={false}
            doneMaterials={sampleDoneMaterials}
            passedMaterialsCount={10}
            isOnBoarding="true"
            ButtonState="firstBoarding"
          />
        )
      }
      {
        onBoardingStatus === 'secondTutorialScreen'
        && (
          <StaticGameScreen
            questionIndex={4}
            currentLevel={1}
            modalVisible={false}
            doneMaterials={sampleDoneMaterials}
            passedMaterialsCount={10}
            isOnBoarding="true"
            ButtonState="secondBoarding"
          />
        )
      }
      {
        onBoardingStatus === 'inGame'
        && (
          <>
            {gameImages.map((url, index) => (
              <Image src={url} onLoad={() => onLoad(index)} key={url} alt="Material image" />
            ))}
            {!isLoaded ? (
              <>
                <PleaseWait>{__('app.please_wait')}</PleaseWait>
                <LoadingComp />
              </>
            ) : (
              <>
                {
                  !countDownWaiting && (
                    <StaticGameScreen
                      questionIndex={0}
                      currentLevel={0}
                      modalVisible={false}
                      doneMaterials={[]}
                      passedMaterialsCount={0}
                      isOnBoarding="false"
                      isCountDown="true"
                    />
                  )
                }
                {
                  countDownWaiting && (
                    <Game />
                  )
                }
              </>
            )}
          </>
        )
      }
    </Container>
  );
};

export default connect(
  (store) => ({
    recycleRightData: store.recycleRight.allRrData
  }),
  (dispatch) => ({
    setDiscoveryData: (data) => dispatch(discovery.setDiscoveryData(data))
  })
)(RecycleRIGHT);
